import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }
    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '20px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Audience Creation
                                    </h2>
                                    <p>
                                        In the Audience section it's possible to create, edit and delete segments. <br/>

                                        <div className="alert alert-warning">
                                            Please refer to the section <b>"Data Guidelines"</b> when you choose your audience name because there are some restrictions in how you can name your segments: <a href="https://www.google.com/doubleclick/dataplatform/policies.html">Google Data Platform Policies</a>.
                                        </div>

                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Dashboard: Audience creation
                                        </h3>
                                        <p>
                                            <ol>
                                                <li>
                                                    By clicking the <u>"New Audience"</u> button you can set the <b>audience name</b> and a <b>description</b>.
                                                    The description is an optional parameter, but it's good to write it for better reach on the marketplace.
                                                </li>
                                                <li>
                                                    It's possible to select a <b>branding prefix using the partner name</b> in the audience name selecting{' '}
                                                    <u>"Branded"</u> option.
                                                </li>
                                                <li>
                                                    Clicking <u>"Save"</u> button will create the audience.
                                                </li>
                                            </ol>
                                        </p>
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
